import { render, staticRenderFns } from "./ImporterDownloadWarning.vue?vue&type=template&id=7c9800ce&scoped=true&"
import script from "./ImporterDownloadWarning.vue?vue&type=script&lang=ts&"
export * from "./ImporterDownloadWarning.vue?vue&type=script&lang=ts&"
import style0 from "./ImporterDownloadWarning.vue?vue&type=style&index=0&id=7c9800ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9800ce",
  null
  
)

export default component.exports